import '../styles/Common.css';
import '../styles/About.css';
import {useTranslation, Trans} from "react-i18next";
import {Helmet} from 'react-helmet-async';
import SEO from "./SEO";
import heroBackgroundImage from '../assets/images/hero_background/about_hero_bg_original4.jpg';
import React from "react";
import {useParams} from "react-router-dom";


const About = () => {
    const {t, i18n} = useTranslation(['about', 'common', 'title', 'home'])
    const isChinese = i18n.language.includes('zh');
    const principles = t(`principles`, {ns: 'home', returnObjects: true});

    return (
        <div className={"bg-white"}>
            <SEO title={t('about', {ns: 'html_title'})}></SEO>
{/*            <div className={"header-container"}>
                <div className={"header"}>
                    <div className={"header-title-1"}>{t('about')} {t('project_name_full', {ns: 'common'})}</div>
                    <div className={"header-title-2"}>{t('title')}</div>
                </div>
            </div>*/}
            <div className={"bg-cover bg-white bg-blend-hard-light bg-bottom bg-no-repeat min-h-[350px] sm:min-h-[400px] w-full flex flex-col justify-start items-center p-6"}
                 style={{backgroundImage: `url(${heroBackgroundImage})`}}
            >
                <div className={"flex flex-col justify-center items-start max-w-[950px] mt-36 mb-16 md:mr-48"}>
                    <div className={`font-bold tracking-[.02em] text-white/90 leading-normal ${isChinese ? 'text-4xl sm:text-[3.5rem] sm:tracking-[.05em]' : 'text-4xl sm:text-[3rem] sm:tracking-[.03em]'}`}>
                        {t('about')}<br/>
                        {t('subtitle')}
                    </div>
                </div>
            </div>
            <div className={"content-container py-24"}>
                <div className={"flex flex-wrap justify-evenly items-start max-w-8xl mx-auto px-6 sm:px-12 pb-36 rounded-3xl bg-cover bg-white bg-blend-multiply bg-center-top bg-no-repeat"}>
                    <div id={"logo_animation"} className={"flex justify-center items-center flex-col pt-0 pb-6 bg-white"}>
                        <video
                            src={process.env.PUBLIC_URL + `/logo/red_logo_min.mp4`}
                            className={"w-full max-w-[400px] bg-white rounded-full p-[2px]"}
                            loop
                            muted
                            autoPlay
                        />
                    </div>
                    <div className={"lg:max-w-[60%]"}>
                        <p className={`max-w-[900px] mt-6 text-xl font-medium font-sans text-[#c00000] sm:text-[#c00000] sm:text-xl leading-loose ${isChinese ? 'tracking-[.05em] sm:tracking-[.01em]' : 'text-left tracking-[.01em] sm:tracking-[.01em]'}`}>
                            {t('hero_heading_3', {ns: 'home'})}
                        </p>
                        <ul className={`list-disc pl-5 max-w-[900px] mt-3 mb-5 text-xl font-light font-sans text-neutral-700 sm:text-neutral-700 sm:text-xl leading-loose sm:leading-8 ${isChinese ? 'tracking-[.05em] sm:tracking-[.01em]' : 'text-left tracking-[.01em] sm:tracking-[.01em]'}`}>
                            {principles && principles.map((item, index) => (
                                <li key={index} className="mb-1.5">{item}</li>
                            ))}
                        </ul>
                        <p className={`max-w-[900px] mt-6 mb-3 text-xl font-medium font-sans text-[#c00000] sm:text-[#c00000] sm:text-xl leading-loose ${isChinese ? 'tracking-[.05em] sm:tracking-[.01em]' : 'text-left tracking-[.01em] sm:tracking-[.01em]'}`}>
                            {t('title_institute_intro')}
                        </p>
                        <div className="text-neutral-600 text-xl font-light font-sans leading-loose">
                            <p>{t('paragraph1')}</p>
                            <p className="mt-4">{t('paragraph2')}</p>
                            <p className="mt-24">
                                {t('contact')}<a href={`mailto:${t('email')}`} target={"_blank"} rel="noreferrer">{t('email')}</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;
